// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zAFQ","newExpiryDate":"styles_newExpiryDate__22kJU","footer":"styles_footer__3SxeD"};